export const Quiz = [
  {
    slug: 'welcome',
    components: [
      {
        component: 'title',
        classes: '!mt-2',
        title: 'Optimize your <br> phone in a minute!',
      },
      {
        component: 'description',
        description: 'Choose the issue you’d like to fix first.',
      },
      {
        component: 'radioGrid',
        name: 'welcome-info',
        items: [
          {
            title: 'Remove duplicate photos & videos',
            icon: '/quiz/icons/gallery.png',
          },
          {
            title: 'Free up storage space',
            icon: '/quiz/icons/storage.png',
          },
          {
            title: 'Improve battery performance',
            icon: '/quiz/icons/battery-orange.png',
          },
          {
            title: 'Get rid of spam & junk',
            icon: '/quiz/icons/spam.png',
          },
        ],
      },
      {
        component: 'privacyBottom',
        icon: '/quiz/icons/protection.svg',
        content:
          'Please check our <a href="#">Privacy Policy</a> to understand how we use your data',
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: false,
      },
      prevButton: {
        hide: true,
      },
      progress: false,
    },
  },
  {
    slug: 'user-count',
    components: [
      {
        component: 'image',
        src: '/quiz/images/second-screen-crop.png',
        width: 200,
        height: 200,
        alt: 'Image',
      },
      {
        component: 'userCountBanner',
        numbers: '30 000 000<span>+</span>',
        text: 'People already use Clean Master',
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        static: true,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: false,
    },
  },
  {
    slug: 'clear-the-clutter',
    components: [
      {
        component: 'image',
        src: '/quiz/images/clear.jpg',
        width: 200,
        height: 200,
        alt: 'Image',
        classes: '!w-[92%] !mx-auto',
      },
      {
        component: 'cardsSwiper',
        items: [
          {
            icon: '/quiz/icons/spam.png',
            title: 'Constant spam alerts & ads',
          },
          {
            icon: '/quiz/icons/battery-orange.png',
            title: 'Drains too fast, needs optimization',
          },
          {
            icon: '/quiz/icons/warning.png',
            title: 'Phone is slowing down',
          },
          {
            icon: '/quiz/icons/storage-alert.png',
            title: 'Almost full, cluttered with junk',
          },
        ],
      },
      {
        component: 'title',
        title: 'Clear the clutter',
      },
      {
        component: 'description',
        description:
          'Clean Master removes the clutter — photos, files, and more. Your phone feels lighter, faster, and refreshed.',
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Start Cleaning',
      },
      prevButton: {
        hide: false,
      },
      progress: false,
    },
  },
  {
    slug: 'primary-goal',
    components: [
      {
        component: 'title',
        title: 'What’s your main goal?',
        isSmall: 'true',
      },
      {
        component: 'description',
        description: 'You can select multiple goals',
      },
      {
        component: 'checkboxButtons',
        name: 'primary-goal',
        items: [
          {
            title: 'Free up storage space',
            icon: '/quiz/icons/storage.png',
          },
          {
            title: 'Make my phone faster',
            icon: '/quiz/icons/faster.png',
          },
          {
            title: 'Remove duplicate photos & videos',
            icon: '/quiz/icons/gallery.png',
          },
          {
            title: 'Get rid of spam & junk',
            icon: '/quiz/icons/spam.png',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: true,
        text: 'Continue',
        disabledText: 'Select at least one',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'first-step-taken',
    components: [
      {
        component: 'title',
        title: 'It starts here',
        classes: 'mt-4',
        isSmall: 'true',
      },
      {
        component: 'description',
        description:
          'We’ve started clearing duplicate photos, junk files, and spam. Get ready to see your phone run smoother and faster.',
      },
      {
        component: 'image',
        src: '/quiz/images/image3.jpg',
        width: 200,
        height: 200,
        classes: '!mt-6 !w-[92%] !mx-auto',
        alt: 'Image',
        hasTopGap: true,
        hasBottomGap: true,
      },
      {
        component: 'description',
        bold: true,
        description:
          'Your phone is already getting lighter and faster as we remove what you don’t need.',
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'phone-condition',
    components: [
      {
        component: 'title',
        title: "How is your phone's condition?",
        isSmall: 'true',
      },
      {
        component: 'radioButtons',
        name: 'phone-condition',
        items: [
          {
            title: 'A bit cluttered',
            icon: '/quiz/icons/storage-space.png',
          },
          {
            title: 'Runing slow & heavy',
            icon: '/quiz/icons/frozen.png',
          },
          {
            title: 'Almost full & overload',
            icon: '/quiz/icons/storage-alert.png',
          },
          {
            title: 'Not sure',
            icon: '/quiz/icons/not-sure.png',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: false,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'after-clear',
    components: [
      {
        component: 'title',
        title: 'How should your phone <br> feel after clearing?',
        isSmall: 'true',
      },
      {
        component: 'radioButtons',
        name: 'after-clear',
        items: [
          {
            title: 'Fast & smooth',
            icon: '/quiz/icons/faster.png',
          },
          {
            title: 'Organized & clean gallery',
            icon: '/quiz/icons/gallery.png',
          },
          {
            title: 'More free storage space',
            icon: '/quiz/icons/storage.png',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: false,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'phone-areas',
    components: [
      {
        component: 'title',
        title: 'Which parts of your phone need cleaning most?',
        isSmall: 'true',
      },
      {
        component: 'description',
        description: 'You can select multiple options',
      },
      {
        component: 'checkboxButtons',
        name: 'phone-areas',
        items: [
          {
            title: 'Duplicate photos & videos',
            icon: '/quiz/icons/gallery.png',
          },
          {
            title: 'Junk files',
            icon: '/quiz/icons/file.png',
          },
          {
            title: 'Spam email & notifications',
            icon: '/quiz/icons/spam.png',
          },
          {
            title: 'Contacts & calendar clutter',
            icon: '/quiz/icons/calendar.png',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: true,
        disabledText: 'Select at least one',
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'last-time-phone-worked',
    components: [
      {
        component: 'title',
        title: 'When did your phone last run smoothly?',
        isSmall: 'true',
      },
      {
        component: 'timelineSlider',
        name: 'last-time-phone-worked',
        items: [
          'Less than 1 year ago',
          '1 years ago',
          '2 years ago',
          '3 years ago',
          '4 years ago',
          '5 years ago',
          'More than 5 years ago',
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'doing-great',
    components: [
      {
        component: 'title',
        title: 'You’re doing great!',
        classes: 'mt-3',
        isSmall: 'true',
      },
      {
        component: 'description',
        description:
          'Clarity starts with small steps. You’re giving your phone the focus and speed it needs to feel lighter and faster.',
      },
      {
        component: 'image',
        src: '/quiz/images/image4.png',
        width: 200,
        height: 200,
        alt: 'Image',
        classes: '!mt-6 !w-[92%] !mx-auto',
        hasTopGap: true,
        hasBottomGap: true,
      },
      {
        bold: true,
        component: 'description',
        description: 'We’re preparing your phone for the next step toward peak performance.',
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'how-often-clear-phone',
    components: [
      {
        component: 'title',
        title: 'How often do you clean <br> your phone?',
        isSmall: 'true',
      },
      {
        component: 'radioButtons',
        name: 'how-often-clear-phone',
        items: [
          {
            title: 'Almost every day',
            description: 'I like to keep my phone tidy all the time',
          },
          {
            title: 'Several times per week',
            description: 'I clean up when I remember',
          },
          {
            title: 'Several times per month',
            description: 'Usually only when storage runs low',
          },
          {
            title: 'Never',
            description: 'I’ve never cleaned my phone before',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: true,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'clean-phone-right-now',
    components: [
      {
        component: 'title',
        title: 'How clean is your phone <br> at the moment?',
        isSmall: 'true',
      },
      {
        component: 'radioButtons',
        name: 'clean-phone-right-now',
        items: [
          {
            title: 'Pretty clean',
            description: 'I delete some files myself regularly',
            icon: '/quiz/icons/pretty.png',
          },
          {
            title: 'Just started cleaning',
            description: 'I only recently began organizing my phone',
            icon: '/quiz/icons/cleaning.png',
          },
          {
            title: 'Not very clean',
            description: 'Too much junk is piling up',
            icon: '/quiz/icons/clean.png',
          },
          {
            title: 'Not sure',
            description: 'I don’t know what’s taking up space',
            icon: '/quiz/icons/not-sure.png',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: true,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'how-phone-work',
    components: [
      {
        component: 'title',
        title: 'How does your phone <br> work for you?',
        isSmall: 'true',
      },
      {
        component: 'radioButtons',
        name: 'how-phone-work',
        items: [
          {
            title: 'Very slow',
            description: 'Often freezes and lags',
            icon: '/quiz/icons/slow.png',
          },
          {
            title: 'Sometimes slow',
            description: 'Slows down occasionally',
            icon: '/quiz/icons/sometimes-slow.png',
          },
          {
            title: 'Works okay',
            description: 'Runs fine, not perfect',
            icon: '/quiz/icons/work-okey.png',
          },
          {
            title: 'Fast',
            description: 'Smooth and responsive',
            icon: '/quiz/icons/faster.png',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: true,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'notice-slowdown-phone',
    components: [
      {
        component: 'title',
        title: 'How often do you notice <br> your phone lagging?',
        isSmall: 'true',
      },
      {
        component: 'radioButtons',
        name: 'notice-slowdown-phone',
        items: [
          {
            title: 'Almost every day',
          },
          {
            title: 'A few times per week',
          },
          {
            title: 'Rarely, maybe once a month',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: true,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'goodbye-alerts',
    components: [
      {
        component: 'title',
        title: 'Goodbye, annoying alerts!',
        classes: 'mt-4',
        isSmall: 'true',
      },
      {
        component: 'description',
        description:
          'Enjoy real peace of mind when junk and fake notifications are gone. Your phone feels faster, safer, and more focused.',
      },
      {
        component: 'image',
        src: '/quiz/images/image5.png',
        width: 200,
        height: 200,
        classes: '!mt-4 !w-[92%] !mx-auto',
        alt: 'Image',
        hasTopGap: true,
      },
      {
        component: 'notifications',
        items: [
          {
            title: 'Storage almost full',
            description: 'Your phone is running low on storage',
            icon: '/quiz/icons/storage-alert.png',
            time: 'now',
          },
          {
            title: 'Performance reduced',
            description: 'Your phone may be slowing down',
            icon: '/quiz/icons/warning.png',
            time: '3m ago',
          },
          {
            title: 'Battery draining quickly',
            description: 'Background activity is draining power',
            icon: '/quiz/icons/battery-orange.png',
            time: '9m ago',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'get-annoying-alerts',
    components: [
      {
        component: 'title',
        title: 'Do you get annoying <br> alerts  on your phone?',
        isSmall: 'true',
      },
      {
        component: 'description',
        description: 'You can select multiple options',
      },
      {
        component: 'checkboxButtons',
        name: 'get-annoying-alerts',
        items: [
          {
            title: 'Storage almost full alerts',
            icon: '/quiz/icons/storage-alert.png',
          },
          {
            title: 'Phone is slowing down warnings',
            icon: '/quiz/icons/warning.png',
          },
          {
            title: 'Random spam notifications',
            icon: '/quiz/icons/random.png',
          },
          {
            title: 'None of the above',
            icon: '/quiz/icons/never.png',
            clearAll: true,
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: true,
        disabledText: 'Select at least one',
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'how-you-use-phone',
    components: [
      {
        component: 'title',
        title: 'How do you usually <br> use your phone?',
        isSmall: 'true',
      },
      {
        component: 'radioButtons',
        name: 'how-you-use-phone',
        items: [
          {
            title: 'Heavy use (work, media, gaming)',
            icon: '/quiz/icons/controller.png',
          },
          {
            title: 'Mostly social media & chatting',
            icon: '/quiz/icons/chat.png',
          },
          {
            title: 'Just calls & essentials',
            icon: '/quiz/icons/phone.png',
          },
          {
            title: 'Barely use it',
            icon: '/quiz/icons/never.png',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: true,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'describe-phone-state',
    components: [
      {
        component: 'title',
        title: 'How would you describe your phone’s typical state?',
        isSmall: 'true',
      },
      {
        component: 'radioButtons',
        name: 'describe-phone-state',
        items: [
          {
            title: 'Always full and cluttered',
            icon: '/quiz/icons/storage-alert.png',
          },
          {
            title: 'I clear it from time to time',
            icon: '/quiz/icons/cleaning.png',
          },
          {
            title: 'Mostly unused space but still messy',
            icon: '/quiz/icons/storage-space.png',
          },
          {
            title: 'Not sure',
            icon: '/quiz/icons/not-sure.png',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: true,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'what-bothers-you',
    components: [
      {
        component: 'title',
        title: 'What annoys you most <br> about your phone?',
        isSmall: 'true',
      },
      {
        component: 'description',
        description: 'You can select multiple options',
      },
      {
        component: 'checkboxButtons',
        name: 'what-bothers-you',
        items: [
          {
            title: 'Duplicate photos & videos',
            icon: '/quiz/icons/gallery.png',
          },
          {
            title: 'Spam emails & alerts',
            icon: '/quiz/icons/spam.png',
          },
          {
            title: 'Phone slow or frozen',
            icon: '/quiz/icons/frozen.png',
          },
          {
            title: 'Files or contacts hard to find',
            icon: '/quiz/icons/file.png',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: true,
        disabledText: 'Select at least one',
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'clean-phone-fresh-start',
    components: [
      {
        component: 'title',
        title: 'A clean phone. A fresh start.',
        classes: 'mt-2',
        isSmall: 'true',
      },
      {
        component: 'description',
        description:
          'A clean phone means faster performance and fewer distractions. Enjoy a smoother, safer, more focused experience.',
      },
      {
        component: 'image',
        src: '/quiz/images/image6.png',
        width: 200,
        height: 200,
        classes: '!mt-4 !w-[89%] !mx-auto',
        alt: 'Image',
        hasTopGap: true,
        hasBottomGap: true,
      },
      {
        component: 'description',
        bold: true,
        description: 'We’ll use what you shared <br> to craft a plan made just for you.',
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'how-quickly-phone-fill-up',
    components: [
      {
        component: 'title',
        title: 'How fast does your <br> phone storage fill up?',
        isSmall: 'true',
      },
      {
        component: 'radioButtons',
        name: 'how-quickly-phone-fill-up',
        items: [
          {
            title: 'Almost instantly',
            description: 'After just a few photos or videos',
          },
          {
            title: 'Slowly',
            description: 'Every few weeks',
          },
          {
            title: 'Rarely',
            description: 'Plenty of space available',
          },
          {
            title: 'Not sure',
            description: 'Only notice when it’s too late',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: false,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'how-often-phone-charge',
    components: [
      {
        component: 'title',
        title: 'How often do you <br> charge your phone?',
        isSmall: 'true',
      },
      {
        component: 'radioButtons',
        name: 'how-often-phone-charge',
        items: [
          {
            title: 'Several times a day',
            description: 'The battery drains too fast',
          },
          {
            title: 'Once a day',
            description: 'Is usually enough',
          },
          {
            title: 'Every 2–3 days',
            description: 'Battery lasts well',
          },
          {
            title: 'None of the above',
            description: 'I just charge it whenever I can',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: false,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'which-habits-drains',
    components: [
      {
        component: 'title',
        title: 'Which habits drain <br> your phone the most?',
        isSmall: 'true',
      },
      {
        component: 'description',
        description: 'You can select multiple options',
      },
      {
        component: 'checkboxButtons',
        name: 'which-habits-drains',
        items: [
          {
            title: 'Too many apps in background',
            icon: '/quiz/icons/app.png',
          },
          {
            title: 'Rarely restarting phone',
            icon: '/quiz/icons/restart.png',
          },
          {
            title: 'Wi-Fi & Bluetooth always on',
            icon: '/quiz/icons/wifi.png',
          },
          {
            title: 'Max brightness always on',
            icon: '/quiz/icons/brightness.png',
          },
          {
            title: 'Not sure',
            icon: '/quiz/icons/not-sure.png',
            clearAll: true,
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: true,
        text: 'Continue',
        disabledText: 'Select at least one',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'what-slows-down-phone',
    components: [
      {
        component: 'title',
        title: 'What slows down <br> your phone the most?',
        isSmall: 'true',
      },
      {
        component: 'description',
        description: 'You can select multiple options',
      },
      {
        component: 'checkboxButtons',
        name: 'what-slows-down-phone',
        items: [
          {
            title: 'Too many photos & videos',
            icon: '/quiz/icons/gallery.png',
          },
          {
            title: 'Too many apps',
            icon: '/quiz/icons/app.png',
          },
          {
            title: 'Pop-ups & ads',
            icon: '/quiz/icons/popup.png',
          },
          {
            title: 'Storage full of old files',
            icon: '/quiz/icons/storage-alert.png',
          },
          {
            title: 'Not sure',
            icon: '/quiz/icons/not-sure.png',
            clearAll: true,
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: true,
        text: 'Continue',
        disabledText: 'Select at least one',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'phone-will-feel-fresh-again',
    components: [
      {
        component: 'title',
        title: 'Fresh. Fast. Effortless.',
        classes: 'mt-3',
        isSmall: 'true',
      },
      {
        component: 'description',
        description:
          'Slow apps, full storage, and clutter fade away. Clean Master refreshes your device to run faster and smoother.',
      },
      {
        component: 'image',
        src: '/quiz/images/image7.png',
        classes: 'small !mt-4 !w-[92%] !mx-auto',
        width: 200,
        height: 200,
        alt: 'Image',
        hasTopGap: true,
        hasBottomGap: true,
      },
      {
        component: 'description',
        bold: true,
        description: 'You’re all set to keep <br> your phone running smoothly.',
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'how-old-your-phone',
    components: [
      {
        component: 'title',
        title: 'How old is your phone?',
        isSmall: 'true',
      },
      {
        component: 'numberCounter',
        defaultValue: 2,
        name: 'how-old-phone',
        min: 1,
        max: 50,
      },
      {
        isSmall: 'true',
        component: 'description',
        description:
          'This helps us tweak your cleaning plan. Older phones tend to gather more junk files and slow down, so we’ll make sure the process works better for your device.',
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'phone-health-profile',
    components: [
      {
        component: 'title',
        title: 'Here is your phone’s <br> health profile',
        isSmall: true,
        classes: 'mt-4',
      },
      {
        component: 'graphProfile',
        subtitle: 'Phone perfomance',
        percents: '30%',
        graph: '/quiz/images/graph.png',
      },
      {
        component: 'list',
        items: [
          {
            title: 'Constant spam alerts & ads',
            icon: '/quiz/icons/spam.png',
          },
          {
            title: 'Drains too fast, needs optimization',
            icon: '/quiz/icons/optimization.png',
          },
          {
            title: 'Phone is slowing down',
            icon: '/quiz/icons/warning.png',
          },
          {
            title: 'Almost full, cluttered with junk',
            icon: '/quiz/icons/storage-alert.png',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'clean-phone-works-faster',
    components: [
      {
        component: 'title',
        title: 'Clarity that lasts',
        classes: 'mt-4',
        isSmall: true,
      },
      {
        component: 'description',
        description:
          'A clutter-free phone runs smoother, saves battery, and stays fast. With Clean Master, your device performs at its best every day.',
      },
      {
        component: 'image',
        src: '/quiz/images/image8.png',
        width: 200,
        height: 200,
        classes: '!mt-4 !w-[92%] !mx-auto',
        alt: 'Image',
        hasTopGap: true,
        hasBottomGap: true,
      },
      {
        component: 'description',
        bold: true,
        description: 'No need to lift a finger.<br>We’ll take care of it in moments.',
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'clean-master-screen',
    components: [
      {
        component: 'title',
        title: 'Keep it fast and clean',
        classes: 'mt-4',
        isSmall: true,
      },
      {
        component: 'description',
        description: 'See how smooth it can be.',
      },
      {
        component: 'performance',
        description: 'See how smooth it can be.',
        title: 'Performance boost',
        image: '/quiz/images/performance.svg',
        icon: '/quiz/icons/performance.svg',
      },
    ],
    navigation: {
      nextButton: {
        hide: false,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'analyzing-screen',
    components: [
      {
        component: 'progressLoader',
        items: [
          {
            title: 'Analyzing your <br> phone’s junk files…',
            description:
              'We’re finding photos, spam, and hidden <br> files that waste your storage.',
            percent: 20,
          },
          {
            title: 'Checking what slows <br> your phone down…',
            description: 'Identifying apps and junk <br> that drain your battery.',
            percent: 40,
          },
          {
            title: 'Scanning your <br> phone for issues…',
            description: 'Detecting spam notifications that <br> interrupt you every day.',
            percent: 60,
          },
          {
            title: 'Optimizing your <br> phone’s performance…',
            description: 'Locating unused files to <br> free up your memory.',
            percent: 80,
          },
          {
            title: 'Preparing your <br> phone for cleaning…',
            description:
              'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
            percent: 100,
          },
        ],
      },
      {
        component: 'reviews',
        items: [
          {
            name: 'Floyd Miles',
            avatar: '/quiz/images/author1.png',
            title: 'Battery drain',
            review:
              '“My phone battery used to die in just a few hours. After cleaning unused apps, the battery lasts much longer.”',
          },
          {
            name: 'Cameron Williamson',
            avatar: '/quiz/images/author2.png',
            title: 'Spam & pop-ups',
            review:
              '“I was very annoyed by spam messages and ads. Clean Master removed all that junk, now my phone feels peaceful.”',
          },
          {
            name: 'Brooklyn Simmons',
            avatar: '/quiz/images/author3.png',
            title: 'Slow phone',
            review:
              '“My phone was always freezing, I almost bought a new one. With Clean Master, it works fast again, just like new.”',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: false,
        text: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'your-email',
    components: [
      {
        component: 'title',
        title: 'Enter your email to get <br> Clean Master app',
        isSmall: 'true',
      },
      {
        component: 'email',
        name: 'your-email',
      },
      {
        component: 'privacyBottom',
        icon: '/quiz/icons/protection.svg',
        content:
          'Please check our <a href="#">Privacy Policy</a> to understand how we use your data',
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
        disabled: true,
        text: 'Continue',
        disabledText: 'Continue',
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'paywall',
    components: [
      {
        component: 'paywall',
        items: [
          {
            name: '4-week plan',
            solidGateProductID: '0861c564-b777-499a-88ab-6fe079a9a014',
            originalPrice: 39.99,
            discountedPrice: 13.99,
            discountAmount: '26.00',
            perDay: 1.42,
            percentDiscount: 65,
            perDayDiscount: 0.49,
            tag: 'Most popular',
            text: 'Your first subscription includes an automatic discount. After the selected term, it renews at the standard price of $39.99. You can cancel anytime by contacting <a href="mailto:support@clean-master.app">support@clean-master.app</a>',
          },
          {
            name: '12-week plan',
            solidGateProductID: '8f0ef7a6-d617-47a2-b98a-a53bd4962525',
            originalPrice: 64.99,
            discountedPrice: 24.99,
            discountAmount: '40.00',
            percentDiscount: 62,
            perDay: 0.77,
            perDayDiscount: 0.29,
            text: 'Your first subscription includes an automatic discount. After the selected term, it renews at the standard price of $64.99. You can cancel anytime by contacting <a href="mailto:support@clean-master.app">support@clean-master.app</a>',
          },
          {
            name: '24-week plan',
            solidGateProductID: '51fbd12d-5014-4996-9000-e060463c0225',
            originalPrice: 99.99,
            discountedPrice: 39.99,
            discountAmount: '60.00',
            percentDiscount: 60,
            perDay: 0.59,
            perDayDiscount: 0.23,
            tag: 'Best value',
            text: 'Your first subscription includes an automatic discount. After the selected term, it renews at the standard price of $99.99. You can cancel anytime by contacting <a href="mailto:support@clean-master.app">support@clean-master.app</a>',
          },
        ],
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
      },
      prevButton: {
        hide: false,
      },
      progress: true,
    },
  },
  {
    slug: 'checkout',
    screenTitle: 'Order review',
    components: [
      {
        component: 'checkout',
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
      },
      prevButton: {
        hide: false,
      },
      progress: false,
    },
  },
  {
    slug: 'thank-you',
    components: [
      {
        component: 'thankYou',
      },
    ],
    navigation: {
      nextButton: {
        hide: true,
      },
      prevButton: {
        hide: true,
      },
      progress: false,
    },
  },
]
